import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// In-memory map keeps scroll positions only until browser refresh.
const scrollPositions = new Map();

function getRouteKey(location) {
  return `${location.pathname}${location.search}`;
}

function ScrollToTop() {
  const location = useLocation();
  const routeKey = getRouteKey(location);
  const initialLoadHandledRef = useRef(false);

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    let isInitialReload = false;
    if (!initialLoadHandledRef.current) {
      const navEntry = performance.getEntriesByType("navigation")?.[0];
      isInitialReload = navEntry?.type === "reload";
      if (isInitialReload) {
        scrollPositions.clear();
      }
      initialLoadHandledRef.current = true;
    }

    const savedY = scrollPositions.get(routeKey);
    const targetY = isInitialReload ? 0 : (typeof savedY === "number" ? savedY : 0);

    // Single restore avoids visible jump/flicker on refresh.
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: targetY, left: 0, behavior: "auto" });
    });

    return () => {
      scrollPositions.set(routeKey, window.scrollY || window.pageYOffset || 0);
    };
  }, [routeKey]);

  return null;
}

export default ScrollToTop;